import { createReducer } from '@reduxjs/toolkit';
import toggleMenuModal from '../actions/menuTogle';

const initialState = {
  menuVisible: false,
};
export default createReducer(initialState, (builder) => {
  builder.addCase(toggleMenuModal, (state, action) => ({
    ...state,
    menuVisible: action.payload,
  }));
});
